/**
 * コンテンツ遷移用のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import ManualPdf from '../views/content/ManualPdf.vue'
import ManualTeacherPdf from '../views/content/ManualTeacherPdf.vue'
import ManualAcademyPdf from '../views/content/ManualAcademyPdf.vue'

/**
 * コンテンツ用踏み台ページ群
 */
const contentRoutes: Array<RouteConfig> = [
  // 生徒用マニュアル
  {
    path: '/manual',
    name: 'ContentManual',
    component: ManualPdf,
  },
  // 先生用マニュアル
  {
    path: '/teacher/manual',
    name: 'ContentTeacherManual',
    component: ManualTeacherPdf,
  },
  // 塾管理者用マニュアル
  {
    path: '/academy/manual',
    name: 'ContentAcademyManual',
    component: ManualAcademyPdf,
  },
]

export default contentRoutes
